<template>
    <form autocomplete="off"
        @submit.prevent="handleSubmit"
    >
        <input autocomplete="off" name="hidden" type="text" style="display:none;">
        <div class="form-group">
            <label>Aktywny</label>
            <div>
                <input
                    type="checkbox"
                    true-value="1"
                    false-value="0"
                    class="form-control-checkbox"
                    name="active"
                    v-model="user.active"
                    id="active"
                />
            </div>
        </div>
        <div
            class="form-group"
            :class="{'has-error': errors.has('name')}"
        >
            <label>
                Imię i nazwisko
            </label>
            <input
                type="text"
                class="form-control"
                name="name"
                v-model="user.name"
                v-validate="'required'"
            >
            <small
                v-show="errors.has('name')"
                class="text-danger"
            >
                {{ $t( 'field_required' ) }}
            </small>
        </div>
        <div
            class="form-group"
            :class="{'has-error': errors.has('email')}"
        >
            <label>
                E-mail
            </label>
            <input
                type="text"
                class="form-control"
                disabled="disabled"
                name="email"
                v-model="user.email"
                v-validate="'required'"
            >
            <small
                v-show="errors.has('email')"
                class="text-danger"
            >
                {{ $t( 'field_required' ) }}
            </small>
        </div>
        <div
            class="form-group"
            :class="{'has-error': errors.has('phone')}"
        >
            <label>
                Telefon
            </label>
            <input
                type="text"
                class="form-control"
                name="phone"
                v-model="user.phone"
            >
            <small
                v-show="errors.has('phone')"
                class="text-danger"
            >
                {{ $t( 'field_required' ) }}
            </small>
        </div>
        <div
            class="form-group"
            :class="{'has-error': errors.has('roles_id')}"
        >
            <label>
                Rola
            </label>
            <select
                class="form-control m-b"
                name="faq_type_id"
                v-validate="'required'"
                v-model="user.roles_id"
            >
                <option
                    v-for="( role, i ) in rolesList"
                    :key="i"
                    :value=" role.id "
                >
                    {{ role.name }}
                </option>
            </select>
            <small
                v-show="errors.has('roles_id')"
                class="text-danger"
            >
                {{ $t( 'field_required' ) }}
            </small>
        </div>
        <div class="hr-line-dashed"></div>
        <div class="form-group row">
            <div class="col-sm-4 col-sm-offset-2">
                <button class="btn btn-primary btn-sm" type="submit">{{ $t('save') }}</button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'usersEditForm',
    data() {
        return {
            title: 'Edytuj użytkownika',
            loading: false,
            user: {
                active: false,
                name: '',
                email: '',
                phone: '',
                roles_id: null,
                localization_id: null,
                employment_id: null
            },
            rolesList: [],
            localizationsList: [],
            employmentList: []
        }
    },
    created() {
        Promise.all( [
            this.getData(),
            this.getRolesList()
        ] ) .then( () => {
            this.$emit( 'loading', false )
        } )
    },
    methods: {
        async getRolesList() {
            await this.$http.get( 'dictionary/roles' )
                .then( resp => {
                    this.rolesList = resp.data
                } )
        },
        async getData() {
            await this.$http.get( `users/${ this.$route.params.id }` )
                .then( resp => {
                    this.user = resp.data.user
                } )
        },
        handleSubmit() {
            this.$validator.validateAll().then( result => {
                if ( result ) {
                    this.$emit( 'loading', true )
                    this.$http.put( `users/${ this.$route.params.id }`, this.user )
                        .then( () => {
                            this.$emit( 'loading', false )
                            this.$toastr.success( 'Użytkownik został zmieniony' )
                            this.$router.push( { name: 'users' } )
                        } )
                        .catch( err => {
                            this.$toastr.error( this.convertErrorToPopupText( err.data ) )
                            this.$emit( 'loading', false )
                        } )
                }
            } )
        },
        convertErrorToPopupText( error ) {
            const text = []
            if ( error !== undefined && error !== '' ) {
                text.push( '<ul>' )
                for ( const [ key, value ] of Object.entries( error ) ) {
                    text.push( `<li> ${value.join( ' ' )} </li>` )
                }
                text.push( '</ul>' )
            }
            return text.join( '' )
        }
    }
}
</script>
<style>
input[type="radio"], input[type="checkbox"] {
  width: 15px;
  height: 15px;
  padding-right: 20px;;
}
</style>
